// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrderPage_wrapper__VGG9Y","content":"OrderPage_content__R_L4C"};